import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-sign-up-confirmation',
  templateUrl: './sign-up-confirmation.component.html',
  styleUrls: ['./sign-up-confirmation.component.css'],
})
export class SignUpConfirmationComponent implements OnInit {
  loading: boolean = true;
  token: string = '';
  password: string = '';
  confirmPassword: string = '';
  error: string = '';
  verified: boolean = false;

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.paramMap.get('token') || '';
    this.decryptObject();
  }

  decryptObject() {
    this.authService.decryptObject(this.token).subscribe((res) => {
      var user: any = res.body;
      if (user.isActive == 'V') {
        this.verified = true;
      } else if (user.isActive == 'Y') {
        this.router.navigate(['/login']);
      }
      this.loading = false;
    });
  }

  Submit() {
    var error = '';
    if (!this.password) {
      error = 'Password is Required.';
    } else if (!this.confirmPassword) {
      error = 'Confirm Password is Required.';
    } else if (this.password != this.confirmPassword) {
      error = 'Password and Confirm Password must be same.';
    } else if (this.password.length < 8) {
      error = 'Password must be 8 characters long.';
    }
    if (error) {
      this.toastr.error(error);
    } else {
      this.error = '';
      this.toastr.info('Setting up your account');
      var payload = {
        password: this.password,
        password_confirmation: this.confirmPassword,
      };
      this.authService.confirmAccount(this.token, payload).subscribe((res) => {
        this.toastr.clear();
        this.toastr.success(
          'Please wait for account activation email from Mathecad Team.',
          'Email Verified.'
        );
        this.router.navigate(['/login']);
      });
    }
  }
}
